import { TabList, Tabs, TabSlot, TabTrigger } from 'expo-router/ui';
import { Platform, StyleSheet } from 'react-native';
import { SafeAreaView, useSafeAreaInsets } from 'react-native-safe-area-context';

import { donationIcon, engageIcon, homeIcon, impactIcon, profileIcon, transactionsIcon } from '@/assets/images/icons';
import TabButton from '@/components/TabButton';
import { Colors } from '@/constants/Colors';
import { useAuth } from '@/contexts/authContext';
import { useColorScheme } from '@/hooks/useColorScheme';
import { i18n } from '@/utils/i18n';
import { usePathname } from 'expo-router';

export default function TabLayout() {
  const colorScheme = useColorScheme();

  const { state } = useAuth();
  const { top, bottom } = useSafeAreaInsets();
  const pathname = usePathname();

  const isNonProfitOrg = state.user?.user.role === 'NON_PROFIT_ORG';

  return (
    <SafeAreaView
      style={[styles.safeArea, { paddingTop: Platform.OS === 'android' && !pathname.includes('profile') ? top : 0 }]}
      edges={['bottom']}>
      <Tabs>
        <TabSlot />
        <TabList
          style={{
            ...styles.tabBarStyle,
            height: 93 - bottom,
            backgroundColor: Colors[colorScheme === 'dark' ? 'dark' : 'light'].background
          }}>
          <TabTrigger name="home" href="/home/npoTabs" asChild>
            <TabButton iconSource={homeIcon} label={i18n.t('bottom_tab.home')} />
          </TabTrigger>
          {!isNonProfitOrg && (
            <TabTrigger
              name="donation"
              href={{
                pathname: '/(app)/(bottomTabs)/donation',
                params: {
                  npoName: undefined,
                  amount: 0
                }
              }}
              asChild>
              <TabButton iconSource={donationIcon} label={i18n.t('bottom_tab.donation')} />
            </TabTrigger>
          )}
          <TabTrigger name="engage" href="/(app)/(bottomTabs)/engage/volunteerEngage" asChild>
            <TabButton iconSource={engageIcon} label={i18n.t('bottom_tab.engage')} />
          </TabTrigger>
          <TabTrigger name="impact" href="/impact" asChild>
            <TabButton iconSource={impactIcon} label={i18n.t('bottom_tab.impact')} />
          </TabTrigger>
          {state.authReady && state.user && isNonProfitOrg && (
            <TabTrigger name="transactionsNpo" href="/transactionsNpo" asChild>
              <TabButton iconSource={transactionsIcon} label={i18n.t('bottom_tab.transactions')} />
            </TabTrigger>
          )}
          <TabTrigger
            name="profile"
            href={
              state.authReady && !state.user
                ? '/profile/browseOnly'
                : isNonProfitOrg
                  ? '/profile/npoProfile/insights'
                  : '/profile/individual'
            }
            asChild>
            <TabButton iconSource={profileIcon} label={i18n.t('bottom_tab.profile')} />
          </TabTrigger>
        </TabList>
      </Tabs>
    </SafeAreaView>
  );
}

const styles = StyleSheet.create({
  safeArea: {
    flex: 1,
    backgroundColor: 'white'
  },

  tabBarStyle: {
    borderTopColor: 'rgba(0, 0, 0, 0.15)',
    borderTopWidth: 0.5
  }
});
